import axios from 'axios';
import { API_AUTH, API_EXTRANET, API_FICHA_TECNICA, API_SERVICIOS, BASE_MAPS, BASE_TAIL_MAPS } from 'config/config';
/* import config from 'services/auth/jwt/config'; */

/* const user = JSON.parse(sessionStorage.getItem('user')); */

export const SESSION_TIMER = 3599000; //(1800000 para media hora) se setea el timer en milisegundos

/*-------------------------helpers de cacheo -------------------------*/
const CACHE_TTL = 60 * 60 * 1000; // 1 hora

const getToken = () => JSON.parse(sessionStorage.getItem('user')).token;

const getCachedAxios = async (cacheKey, config, ttl = CACHE_TTL) => {
  const cached = sessionStorage.getItem(cacheKey);

  if (cached) {
    const parsed = JSON.parse(cached);

    if (Date.now() - parsed.timestamp < ttl) {
      return {
        data: parsed.data,
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
        fromCache: true,
      };
    }
  }

  const response = await axios(config);

  sessionStorage.setItem(
    cacheKey,
    JSON.stringify({
      timestamp: Date.now(),
      data: response.data,
    })
  );

  return response;
};

const cachedHeaders = () => ({
  Authorization: `Bearer ${getToken()}`,
});

/*------------------------- fin helpers de cacheo -------------------------*/

/*------------------------- servicios cacheados -------------------------*/

export const getDatosServiciosDeSaludFichasTecnicas = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/ef_servicio_salud',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_ef_servicio_salud', config);
};

export const getRegiones = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/region',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_region', config);
};

export const getDependenciasFichasTecnicas = async () => {
  const config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/tipo_admin?skip=0&limit=100',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_tipo_admin', config);
};

export const getTipoAtencionFichasTecnicas = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/ef_tipo_atencion?skip=0&limit=100',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_ef_tipo_atencion', config);
};

export const getEF_AdministradorFichasTecnicas = async () => {
  const config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/administrador?skip=0&limit=100',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_administrador', config);
};

export const getProvincias = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/provi?skip=0&limit=1000',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_provincias', config);
};

export const getAutoridadesPorRegion = async (id_region) => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/auto_autorizante_r/' + id_region,
    headers: cachedHeaders(),
  };

  return await getCachedAxios(`cache_auto_autorizante_r_${id_region}`, config);
};

export const getProfesiones = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/profesion',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_profesion', config);
};

export const getTipoContrato = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/tipo_contrato',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_tipo_contrato', config);
};

export const getUnidadFuncional = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/unidad-funcional',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_unidad_funcional', config);
};

export const getTipoJornada = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/tipo_jornada',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_tipo_jornada', config);
};

export const getSexo = async () => {
  const config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/sexo',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_sexo', config);
};

export const getAllCodEquip = async () => {
  const config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/cod-equipo/cod-equip/?skip=0&limit=1000',
    headers: cachedHeaders(),
  };

  return await getCachedAxios('cache_cod_equip_all', config);
};

export const getCodEquipByService = async (id_servicio) => {
  const config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/cod-equipo/' + id_servicio + '/cod-equipamiento/',
    headers: cachedHeaders(),
  };

  return await getCachedAxios(
    `cache_cod_equip_service_${id_servicio}`,
    config
  );
};
/*------------------------- fin servicios cacheados -------------------------*/

export const subirAdjuntos = async formData => {
  var config = {
    method: 'post',
    url: API_EXTRANET + 'api/v1/ip/send',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: formData,
  };

  return await axios(config);
};

export const obtenerAdjuntosPorFolio = async data => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/ip/send?run=' + data.run + '&folio=' + data.folio + '&tipo_reclamo=reclamos_ip',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const obtenerAdjuntosIfPorFolio = async data => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/ip/send?run=' + data.run + '&folio=' + data.folio + '&tipo_reclamo=reclamos_if',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const obtenerArchivoPreview = async url => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/file/?url=' + url,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const obtenerArchivoPreviewAdjuntoPorSuper = async url => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/filealfbase64/?link_expediente=' + url,
    /* url: API_EXTRANET + 'api/v1/filealfblob/?link_expediente=' + url, */
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const obtenerArchivoPreviewAdjuntoPorPrestador = async url => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/file/?url=' + url,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      Referer: 'dsrepositorydesa.superdesalud.gob.cl',
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getOrganizationById = async id => {
  var config = {
    method: 'get',
    url: API_AUTH + 'organization/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getNetworkMembers = async id => {
  var config = {
    method: 'get',
    url: API_AUTH + 'network_org/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const disableUser = async usr => {
  var config = {
    method: 'put',
    url: API_AUTH + 'user/' + usr.id,
    data: usr,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const updateUserWithNetwork = async (usrId, data) => {
  var config = {
    method: 'put',
    url: API_AUTH + 'user/' + usrId,
    data: data,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const crearUsuario = async data => {
  var config = {
    method: 'post',
    url: API_AUTH + 'user',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const getUserHasAssignments = async user_id => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/user/assigns/' + user_id + '/reclamos_ip',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const asignarProrroga = async data => {
  var config = {
    method: 'post',
    url: API_EXTRANET + 'api/v1/prorroga/?presentacion=base64',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',

      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const getDataSeguimientoTable = async queryString => {
  var config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/reclaim_ip?entidad=' +
      JSON.parse(sessionStorage.getItem('user')).organization.name +
      queryString,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataSeguimientoGestionadosNetwork = async (entidades) => {
  var config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/gestionados_network?' + entidades,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataSeguimientoGestionadosRed = async (endpoint) => {
  var config = {
    method: 'post',
    url:
      API_EXTRANET +
      'api/v1/gestionados-xpage-red',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: endpoint,
  };

  return await axios(config);
};

export const getDataSeguimientoTableNetwork = async (queryString, entidades) => {
  var config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/reclaim_ip_network?' + entidades +
      queryString,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataGestionadosIp = async queryString => {
  var config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/gestionados?entidad=' +
      JSON.parse(sessionStorage.getItem('user')).organization.name +
      queryString,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataGestionadosIpXpage = async (queryString = '') => {
  const user = JSON.parse(sessionStorage.getItem('user'));

  const config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/gestionados-xpage' +
      queryString, // si algún día agregas filtros o paginación
    headers: {
      Authorization: `Bearer ${user.token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config)

};

export const getDataEnEsperaRespuestaIpXpage = async (queryString = '') => {
  const user = JSON.parse(sessionStorage.getItem('user'));

  const config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/espera-respuesta-xpage' +
      queryString,
    headers: {
      Authorization: `Bearer ${user.token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config)

};


export const getDataDerivacionesNetwork = async (queryStringEntidades) => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/derivaciones_network?' + queryStringEntidades,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataDerivaciones = async () => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/derivaciones',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};


export const getDataDerivacionesIpXpage = async (queryString = '') => {
  const user = JSON.parse(sessionStorage.getItem('user'));

  const config = {
    method: 'get',
    url:
      API_EXTRANET +
      'api/v1/derivaciones-xpage' +
      queryString, // si algún día agregas filtros o paginación
    headers: {
      Authorization: `Bearer ${user.token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    console.error('Error al obtener datos desde XPage:', error);
    throw error;
  }
};


export const getStatsIP = async () => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/stats_ip_global',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

//seguimiento if

export const getTodosLosReclamosIf = async queryString => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/reclaim_if' + queryString,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const autoasignarReclamoIf = async (folio, run) => {
  var config = {
    method: 'post',
    url: API_EXTRANET + 'api/v1/userIf?folio=' + folio + '&run=' + run,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getReclamosAutoasignadosIf = async () => {
  var config = {
    method: 'get',
    url: API_EXTRANET + 'api/v1/userIf',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getRegiones = async () => {
  var config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/region',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getProvincias = async () => {
  var config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/provi?skip=0&limit=1000',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

/* Fichas tecnicas */
export const getFichaTecnica = async (nombrePrestador) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ficha?nombre_prestador=' + nombrePrestador,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getEquipoPorFicha = async (id_ficha) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ft-equip/ficha/' + id_ficha,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getFichaTecnicaPorId = async (id) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ficha/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postUserLog = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/users_log',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const initFichaTecnica = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/init-ftecnica',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const enviarFichaTecnica = async (id_ficha_tecnica) => {
  var config = {
    method: 'put',
    url: API_FICHA_TECNICA + 'api/v1/ficha_ingreso/' + id_ficha_tecnica,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const patchIdentificacionFichaTecnica = async (id, data) => {
  var config = {
    method: 'patch',
    url: API_FICHA_TECNICA + 'api/v1/identidad/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data
  };

  return await axios(config);
};

export const deleteFichaTecnica = async (id) => {
  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/ficha/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getDependenciasFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/tipo_admin?skip=0&limit=100',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const getComplejidadFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ef_complejidad?skip=0&limit=100',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getTipoAtencionFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/ef_tipo_atencion?skip=0&limit=100',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getEF_AdministradorFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/administrador?skip=0&limit=100',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const getPrestIntSer = async (id) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/prestinst-ser/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const deleteSerivioAutSanitaria = async (id_prestador, id_servicio) => {

  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/autoridad-sanitaria-servicio/' + id_prestador + '/' + id_servicio,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);

}

export const getServicioAutSanitaria = async (id_prestador, id_servicio) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/autoridad-sanitaria-servicio/' + id_prestador + '/' + id_servicio,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}

export const postServicioAutSanitaria = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/autoridad-sanitaria-servicio',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
}

export const getServiciosMed = async (id) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/servicios-med/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getEquipamiento = async (id) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/equipamiento/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getNombreAdministracionFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ef_nombre_administracion?skip=0&limit=100',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDatosPrestadorFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url:
      API_FICHA_TECNICA + 'api/v1/ficha?nombre_prestador=' + JSON.parse(sessionStorage.getItem('user')).organization.name,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getDatosServiciosDeSaludFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/ef_servicio_salud',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const getCargosFichasTecnicas = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/cargo',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getEstadosAcreditacion = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/estado_acreditacion',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getProfesiones = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/profesion',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getTipoContrato = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/tipo_contrato',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const getAntiguedad = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/tipo_contrato',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getUnidadFuncional = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/unidad-funcional',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getTipoJornada = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/tipo_jornada',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getSexo = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/sexo',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const getNumeroAcreditaciones = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/n_acreditaciones_realizadas',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getEntidadesAcreditadoras = async () => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/prestadores_acreditados',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataRed = async (redId) => {
  var config = {
    method: 'get',
    url:
      API_AUTH + 'api/v1/network_org/' + redId,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};


export const getMapa = async (calle) => {

  var config = {
    method: 'get',
    url:
      BASE_MAPS + calle + BASE_TAIL_MAPS,

  };

  return await axios(config);
};

/* para llamar al login con token */
export const sendLoginTokenRequest = async (data) => {
  var config = {
    method: 'post',
    url: API_AUTH + 'login/access-token',
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const getPrestadorPorRut = async (rut) => {
  var config = {
    method: 'get',
    url:
      API_SERVICIOS + 'api/v1/get-prestador/?rut=' + rut,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postCrearPersonl = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/ft-personal',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const getDataTableDotacionPersonal = async (id) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ft-personal/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataRepresentantes = async (admin, atencion) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/tipo-autoridades-prestador/' + admin + '/' + atencion,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const downloadEquipMasivoXls = async () => {
  var config = {
    method: 'get',
    responseType: 'blob',
    url: API_FICHA_TECNICA + 'api/v1/ft-equip/template_equip_xls/',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const downloadCargaMasivaXls = async () => {
  var config = {
    method: 'get',
    responseType: 'blob',
    url: API_FICHA_TECNICA + 'api/v1/ft-personal/template_xls/',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const subirCargaMasivaEquipFt = async (formData, id_ficha) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/ft-equip/process_xls/?id=' + id_ficha,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: formData,
  };

  return await axios(config);
};

export const subirCargaMasivaFt = async (formData, id_ficha) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/ft-personal/process_xls/?id=' + id_ficha,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: formData,
  };

  return await axios(config);
};

export const deletePersonal = async (id_ficha, id_personal) => {
  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/ft-personal/' + id_ficha + '/' + id_personal,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getDataDirectorio = async (ficha_id) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/autoridades-prest/' + ficha_id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postCreateRepresentante = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/autoridades-prest',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const patchRepresentante = async (id, data) => {
  var config = {
    method: 'patch',
    url: API_FICHA_TECNICA + 'api/v1/autoridades-prest/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data
  };

  return await axios(config);
};

export const deleteRepresentante = async (id) => {
  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/autoridades-prest/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postCreateAutorizacionSanitaria = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/aut-sanitaria',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const deleteAutorizacionSanitaria = async (id_autorizacion) => {

  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/aut-sanitaria/' + id_autorizacion,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);

}

export const getEquipft = async (idFt, idServ) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ft-equipamiento/' + idFt + '/' + idServ,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postSingleEq = async (formData, id_ficha) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/ft-equip/ficha/' + id_ficha + '/',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: formData,
  };

  return await axios(config);
};

/* export const getAllCodEquip = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/cod-equipo/cod-equip/?skip=0&limit=1000',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getCodEquipByService = async (id_servicio) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/cod-equipo/' + id_servicio + '/cod-equipamiento/',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const putEquipamientoFicha = async (data, id) => {
  var config = {
    method: 'put',
    url: API_FICHA_TECNICA + 'api/v1/ft-equip/ficha/' + id + '/',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const deleteEquipoFromFicha = async (id_ficha, id_registro) => {
  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/ft-equip/ficha/' + id_ficha + '/equipo/' + id_registro,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getUsersLogAll = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/users_log?skip=0&limit=1000',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getUsersLogByEntidad = async (nombreEntidad) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/users_log/entidad?entidad=' + nombreEntidad,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postEquipFt = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/ft-equipamiento',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
}

export const patchEquipFt = async (data, id) => {
  var config = {
    method: 'patch',
    url: API_FICHA_TECNICA + 'api/v1/ft-equipamiento/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const deleteEquipFt = async (id) => {
  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/ft-equipamiento/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const postFtServEsp = async (data) => {
  var config = {
    method: 'post',
    url: API_FICHA_TECNICA + 'api/v1/ft-capacidad-inst',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const putFtServEsp = async (data, id) => {
  var config = {
    method: 'put',
    url: API_FICHA_TECNICA + 'api/v1/ft-capacidad-inst-upd/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    data: data,
  };

  return await axios(config);
};

export const deleteFtServEsp = async (id) => {
  var config = {
    method: 'delete',
    url: API_FICHA_TECNICA + 'api/v1/ft-capacidad-inst-del/' + id,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getFtServEsp = async (id_ficha, id_servicio) => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/ft-capacidad-inst/' + id_ficha + '/' + id_servicio,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

/* export const getAutoridadesPorRegion = async (id_region) => {
  var config = {
    method: 'get',
    url: API_SERVICIOS + 'api/v1/auto_autorizante_r/' + id_region,
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
}; */

export const getGuiaCodigosEquipamiento = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/files/guia-codigos',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getGuiaCodigosEquipamientoXlsx = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/files/codigos-equipos',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};

export const getEspecificacionDotacion = async () => {
  var config = {
    method: 'get',
    url: API_FICHA_TECNICA + 'api/v1/files/especificacion-dotacion',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).token}`,
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
  };

  return await axios(config);
};